module.exports = __webpack_public_path__ + "static/media/Shox 01 BG.53fc84c4.png";